export { default } from './image-modal'
